var _defs, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A90E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#003B73"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    rx: 15,
    ry: 15,
    width: 80,
    height: 80,
    fill: "url(#gradient)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 55,
    fill: "white",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif"
  }, "\r\n    IMAP\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImap);
export default __webpack_public_path__ + "static/media/imap.6ac54fb55433a2546c5c260916527b5b.svg";
export { ForwardRef as ReactComponent };